import React, { Component } from 'react';

export class FAQPage extends Component {
  render(){
    return (
      <div>FAQPage</div>
    )
  }
}
